var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.entity
      ? _c("div", { staticClass: "tile is-ancestor is-parent" }, [
          _c("div", { staticClass: "tile is-parent is-vertical" }, [
            _c("article", { staticClass: "tile is-child box" }, [
              _c("p", { staticClass: "title" }, [_vm._v("PNET Details")]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.readOnly,
                          expression: "readOnly",
                        },
                      ],
                      staticClass: "is-checkradio is-info",
                      attrs: { type: "checkbox", id: "readOnly" },
                      domProps: {
                        checked: Array.isArray(_vm.readOnly)
                          ? _vm._i(_vm.readOnly, null) > -1
                          : _vm.readOnly,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.readOnly,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.readOnly = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.readOnly = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.readOnly = $$c
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "readOnly" } }, [
                      _vm._v("Read Only"),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.pnet.extraVehicleInfo,
                          expression: "entity.pnet.extraVehicleInfo",
                        },
                      ],
                      staticClass: "is-checkradio is-info",
                      attrs: { type: "checkbox", id: "extraVehicleInfo" },
                      domProps: {
                        checked: Array.isArray(_vm.entity.pnet.extraVehicleInfo)
                          ? _vm._i(_vm.entity.pnet.extraVehicleInfo, null) > -1
                          : _vm.entity.pnet.extraVehicleInfo,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.entity.pnet.extraVehicleInfo,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.entity.pnet,
                                  "extraVehicleInfo",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.entity.pnet,
                                  "extraVehicleInfo",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.entity.pnet, "extraVehicleInfo", $$c)
                          }
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "part" } }, [
                      _vm._v("Extra Vehicle Info"),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("PNET Qr No"),
                    ]),
                    _c("div", { staticClass: "control quote-width" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.pnet.pnetQuoteNo,
                            expression: "entity.pnet.pnetQuoteNo",
                          },
                        ],
                        staticClass: "input is-uppercase",
                        attrs: { type: "text" },
                        domProps: { value: _vm.entity.pnet.pnetQuoteNo },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity.pnet,
                              "pnetQuoteNo",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Qr Ver")]),
                    _c("div", { staticClass: "control quote-width" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.pnet.quoteRequestVersion,
                            expression: "entity.pnet.quoteRequestVersion",
                          },
                        ],
                        staticClass: "input is-uppercase",
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.entity.pnet.quoteRequestVersion,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity.pnet,
                              "quoteRequestVersion",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "field-body" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("PNET Claim No"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.pnet.claimNo,
                            expression: "entity.pnet.claimNo",
                          },
                        ],
                        staticClass: "input is-uppercase",
                        attrs: { type: "text" },
                        domProps: { value: _vm.entity.pnet.claimNo },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity.pnet,
                              "claimNo",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("PNET Quote No"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.pnet.pnetQuoteNo,
                            expression: "entity.pnet.pnetQuoteNo",
                          },
                        ],
                        staticClass: "input is-uppercase",
                        attrs: { type: "text" },
                        domProps: { value: _vm.entity.pnet.pnetQuoteNo },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity.pnet,
                              "pnetQuoteNo",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.entity
      ? _c("div", { staticClass: "tile is-parent" }, [_vm._m(0)])
      : _vm._e(),
    _vm.entity
      ? _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Image Sent")]),
            _c(
              "div",
              { staticClass: "is-flex is-justify-content-right pt-3" },
              [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: { click: _vm.clearSent },
                  },
                  [_vm._v("Clear Sent")]
                ),
              ]
            ),
          ]),
        ])
      : _c("div", { staticClass: "tile is-ancestor is-parent" }, [_vm._m(1)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("article", { staticClass: "tile is-child box" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Set Quote Status")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("div", [
          _c("p", { staticClass: "title" }, [_vm._v(" Detail ")]),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v("Please select a quote"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }